const account_center = {
    not_enabled: 'O centro de contas não está ativado.',
    filed_not_editable: 'O campo não é editável.',
};
export default Object.freeze(account_center);
